export default "__VITE_ASSET__CcntOAk7__"